/****************************************************************************
 * COPYRIGHT (c) 2024 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/
import {
  FETCH_OEM_ADMIN_COUNTRY_DETAILS_REQUEST,
  FETCH_OEM_ADMIN_COUNTRY_DETAILS_SUCCESS,
  FETCH_OEM_ADMIN_COUNTRY_DETAILS_FAILURE,
} from "./OemAdminCountryDetailsTypes";

const initialState = {
  loading: false,
  countries: [],
  error: "",
};

const OemAdminCountryDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_OEM_ADMIN_COUNTRY_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
      };

      case FETCH_OEM_ADMIN_COUNTRY_DETAILS_SUCCESS: {
        const isSameCountries =
          JSON.stringify(state.countries) === JSON.stringify(action.payload);
      
        return {
          ...state,
          loading: false,
          countries: isSameCountries ? state.countries : action.payload,
          error: "",
        };
      }
    case FETCH_OEM_ADMIN_COUNTRY_DETAILS_FAILURE:
      return {
        loading: false,
        countries: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default OemAdminCountryDetailsReducer;
